import React from 'react';
import { IconButton } from '@mui/material';
import Info from '@mui/icons-material/Info';

interface WikiInfoIconProps {
  /** Additional styles for positioning */
  style?: React.CSSProperties;
  /** Additional sx props for the container */
  sx?: any;
}

/**
 * Reusable wiki info icon - same style as warehouse
 */
const WikiInfoIcon: React.FC<WikiInfoIconProps> = ({ style, sx }) => {
  return (
    <IconButton
      size="small"
      style={style}
      sx={{
        position: 'absolute',
        top: 4,
        right: 4,
        width: 28,
        height: 28,
        backgroundColor: 'rgba(71, 85, 105, 0.3)',
        color: '#cbd5e1',
        zIndex: 2,
        '&:hover': {
          backgroundColor: 'rgba(71, 85, 105, 0.5)',
        },
        ...sx,
      }}
    >
      <Info fontSize="small" />
    </IconButton>
  );
};

export default WikiInfoIcon;